export enum GenderScaleTendency {
  None = 'None',
  Male = 'Male',
  Female = 'Female'
}
